module.exports = __webpack_public_path__ + "static/media/dashboard.0725e6dd.png";